import { render, staticRenderFns } from "./SidebarActions.vue?vue&type=template&id=adcd77f0&scoped=true"
import script from "./SidebarActions.vue?vue&type=script&lang=js"
export * from "./SidebarActions.vue?vue&type=script&lang=js"
import style0 from "./SidebarActions.vue?vue&type=style&index=0&id=adcd77f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcd77f0",
  null
  
)

export default component.exports